import React from 'react';
import properties from '../../constants/Properties';
import locales from '../../locales/LocalesManager';
import mouseUtils from '../../components/utils/MouseUtils';
import platformDetection from '../utils/PlatformDetection';
import apiServiceUtils from '../utils/ApiServiceUtils';
import storeManager from '../../store/StoreManager';
import {connect} from 'react-redux';
import { showAlternativeTextMenu } from '../../actions/MenuActions';
import { changeAlternativeText } from '../../actions/CurrentSlideActions';
import playController from "../utils/PlayController";
import audioEditorUtils from "../audioEditor/utils/AudioEditorUtils";

const Button = React.createClass({
    getInitialState() {
        return ({
            isOver: false
        });
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onButtonClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (this.props.index == 1) {// OK button
            var textInput = document.getElementById('alternativeTextInput');

            if (textInput && textInput.value.length > 0)
                this.props.dispatch(changeAlternativeText(textInput.value));
            else
                this.props.dispatch(changeAlternativeText(''));
        }

        this.props.dispatch(showAlternativeTextMenu(false));
    },
    render() {
        var textColor;
        var fillColor;

        if (this.state.isOver == true) {
            fillColor = properties.SLIDE_VIEWER_BACKGROUND;
            textColor = 'black';
        } else {
            textColor = 'black';
            fillColor = '#f2f2f2';
        }

        const buttonStyle = {
            position: 'absolute',
            backgroundColor: fillColor,
            width: properties.DELETE_ALERT_BUTTON_WIDTH,
            height: properties.DELETE_ALERT_BUTTON_HEIGHT,
            top: this.props.topPosition,
            left: this.props.leftPosition,
            borderRadius: 3,
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#333333'
        };

        const spanStyle = {
            position: 'absolute',
            top: 6,
            fontSize: 16,
            width: properties.DELETE_ALERT_BUTTON_WIDTH - 6,
            whiteSpace: 'nowrap',
            display: 'block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            alignItems: 'center',
            textAlign: 'center',
            cursor: 'default',
            color: textColor
        };

        var buttonId = this.props.index == 1 ? 'alternativeTextOkButton' : undefined;

        return (
            <button aria-label={this.props.text} id={buttonId} style={buttonStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onTouchEnd={this.onButtonClick} onClick={this.onButtonClick}>
                <span style={spanStyle}>{this.props.text}</span>
            </button>
        );
    }
});

export const AlternativeTextForSlideMenuContent = React.createClass({
    componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.showAlternativeTextMenu == true && this.props.showAlternativeTextMenu != nextProps.showAlternativeTextMenu) {
           setTimeout(function() {
               this.changeFocus();
           }.bind(this), 10);
        }
    },
    getInitialState () {
        this.changeSelection();

        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onInputClick() {
        this.changeFocus();
    },
    changeFocus() {
        var view = this.refs.alternativeTextInput;

        if (view)
            view.focus();
    },
    getDefaultTitle() {
        if (this.props.alternativeText)
            return this.props.alternativeText;
        else
            return '';
    },
    changeSelection() {
        if (platformDetection.isIOSApp())
            return;

        setTimeout(function() {
            if (this.refs.alternativeTextInput) {
                this.refs.alternativeTextInput.focus();
                this.refs.alternativeTextInput.setSelectionRange(0, 100);
            }
        }.bind(this), 100);
    },
    render() {
        var visible = 'none';

        if (this.props.showAlternativeTextMenu == true)
            visible = 'block';
        else
            return (<div/>);

        const menuStyle = {
            position: 'absolute',
            width: this.props.windowWidth,
            height: this.props.windowHeight,
            top: apiServiceUtils.getNoInternetConnectionAlertHeight(),
            left: 0,
            display: visible,
            zIndex: 20000
        };

        const backgroundStyle = {
            position: 'absolute',
            backgroundColor: properties.DELETE_ALERT_BACKGROUND,
            width: this.props.windowWidth,
            height: this.props.windowHeight,
            top: 0,
            left: 0,
            opacity: properties.DELETE_ALERT_BACKGROUND_OPACITY
        };

        const bottomBarHeight = 120;
        const alertWidth = this.props.windowWidth * 0.8;
        const alertHolderStyle = {
            position: 'absolute',
            top: 200,
            left: this.props.windowWidth / 2 - alertWidth / 2
        };

        const topBarStyle = {
            position: 'absolute',
            backgroundColor: properties.DELETE_ALERT_BACKGROUND,
            width: alertWidth,
            height: properties.DELETE_ALERT_TOP_BAR_HEIGHT,
            top: 0,
            left: 0,
            borderTopLeftRadius: 3,
            borderTopRightRadius: 3,
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: properties.DELETE_ALERT_BACKGROUND
        };

        const bottomBarStyle = {
            position: 'absolute',
            backgroundColor: 'white',
            width: alertWidth,
            height: bottomBarHeight,
            top: properties.DELETE_ALERT_TOP_BAR_HEIGHT,
            left: 0,
            borderBottomLeftRadius: 3,
            borderBottomRightRadius: 3,
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: 'white'
        };

        var paddingLeft = 15;
        const titleStyle = {
            position: 'absolute',
            left: paddingLeft,
            top: 7,
            fontSize: 20,
            width: alertWidth - 2 * properties.DELETE_ALERT_BUTTON_GAP,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default',
            color: 'white'
        };

        var borderColor;
        var textColor;

        if (this.state.isOver == true) {
            borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
            textColor = borderColor;
        } else {
            borderColor = 'black';
            textColor = 'black';
        }

        const inputHolderStyle = {
            width: topBarStyle.width - 2 * paddingLeft,
            height: 30,
            background: 'white',
            position: 'absolute',
            left: paddingLeft,
            top: paddingLeft,
            borderColor: borderColor,
            borderWidth: 2,
            borderStyle: 'solid',
            alignItems: 'center',
            border: 'none'
        };

        var inputStyle = {
            position: 'absolute',
            color: textColor,
            top: 5,
            paddingLeft: 10,
            fontSize: 17,
            width: inputHolderStyle.width - 2 * 10,
            resize: 'none',
            overflow: 'hidden',
            background: 'transparent',
            borderColor: borderColor,
            borderRadius: 5
        };

        if (platformDetection.isIOS())
            inputStyle.top = -3;

        return (
            <div style={menuStyle} role="dialog" id="alternativeTextAlert">
                <div style={backgroundStyle}/>
                <div style={alertHolderStyle}>
                    <div style={topBarStyle}>
                        <label htmlFor='alternativeTextInput' style={titleStyle}>{locales.getCaption('AlternativeTextMenuTitle', 'other')}</label>
                    </div>
                    <div style={bottomBarStyle}>
                        <div style={inputHolderStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onTouchEnd={this.onInputClick}>
                            <input type='text' ref='alternativeTextInput' id='alternativeTextInput' className='titleInput' style={inputStyle} defaultValue={this.getDefaultTitle()} spellCheck='false' autoCorrect='off' autoCapitalize='off' autoComplete='off'/>
                        </div>

                        <Button dispatch={this.props.dispatch} index={0} topPosition={bottomBarHeight - paddingLeft - properties.DELETE_ALERT_BUTTON_HEIGHT} leftPosition={bottomBarStyle.width - 2 * properties.DELETE_ALERT_BUTTON_WIDTH - 2 * paddingLeft} text={locales.getCaption('Cancel', 'save')}/>
                        <Button dispatch={this.props.dispatch} index={1} topPosition={bottomBarHeight - paddingLeft - properties.DELETE_ALERT_BUTTON_HEIGHT} leftPosition={bottomBarStyle.width - properties.DELETE_ALERT_BUTTON_WIDTH - paddingLeft} text={'OK'}/>
                    </div>
                </div>
            </div>
        );
    }
});

function mapStateToProps() {
    const state = storeManager.getState();
    const showAlternativeTextMenu = state.menu.showAlternativeTextMenu;
    const alternativeText = state.currentSlide.model.alternativeText;

    return {
        showAlternativeTextMenu,
        alternativeText
    };
}

export const AlternativeTextForSlideMenu = connect(mapStateToProps)(AlternativeTextForSlideMenuContent);


/** WEBPACK FOOTER **
 ** ./src/components/menus/AlternativeTextForSlideMenu.js
 **/